<template>
  <div class="ped">
    <div class="ped-card card no-margin no-padding">
      <f7-list no-hairlines-md class="ped-form">
        <f7-list-input
          :label="$t('post.headline')"
          floating-label
          :placeholder="$t('post.headline')"
          type="textarea"
          name="headline"
          resizable
          v-model:value="headline"
          :info="$t('post.titleInfo')"
          clear-button
        />

        <f7-text-editor
          class="ped-editor"
          :placeholder="$t('post.content')"
          :value="text"
          @texteditor:change="(v) => (text = v)"
          resizable
          type="texteditor"
          :mode="'toolbar'"
        ></f7-text-editor>
      </f7-list>
    </div>

    <AttachmentPicker />

    <div class="ped-footer">
      <f7-button
        @click="submit"
        :disabled="!canSubmit || creating"
        ripple
        round-ios
        raised
        fill
        large
        class="ped-submit"
      >
        <span v-if="!creating">{{ submitLabel }}</span>
        <f7-preloader v-else :size="20" color="white" />
      </f7-button>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch } from "vue";
import AttachmentPicker from "./AttachmentPicker.vue";
import { useAuthStore } from "../../js/pinia-stores/auth.js";

const props = defineProps({
  userName: { type: String, default: "" },
  userAvatar: { type: String, default: "" },
  submitLabel: { type: String, default: "" },
  creating: { type: Boolean, default: false },
  editing: { type: Boolean, default: false },
  initialHeadline: { type: String, default: "" },
  initialText: { type: String, default: "" },
});

const emit = defineEmits(["submit"]);

const authStore = useAuthStore();
const headline = ref("");
const text = ref("");

watch(
  () => [props.initialHeadline, props.initialText, props.editing],
  ([h, t, editing]) => {
    if (editing) {
      headline.value = h || "";
      text.value = t || "";
    }
  },
  { immediate: true },
);

function clear() {
  headline.value = "";
  text.value = "";
}

defineExpose({ clear });

const canSubmit = computed(() => {
  return (
    headline.value.trim().length > 0 ||
    text.value.trim().length > 0 ||
    (authStore.documentsUrl && authStore.documentsUrl.length > 0)
  );
});

function submit() {
  if (!canSubmit.value || props.creating) return;
  emit("submit", {
    headline: headline.value,
    text: text.value,
  });
}
</script>

<style scoped>
.ped {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.ped-card {
  background: var(--f7-page-bg-color, #fff);
  /* border: 1px solid rgba(28, 28, 30, 0.08); */
  border-radius: 14px;
  /* padding: 4px 12px; */
}

.ped-editor {
  --f7-text-editor-height: 240px;
  --f7-text-editor-border-radius: 12px;
}

.ped-footer {
  /* display: flex;
  justify-content: flex-end; */
}

.ped-submit {
  --f7-button-fill-bg-color: var(--avocash-green, #1a6b42);
  --f7-button-fill-text-color: #fff;
  width: 100%;
  /* max-width: 220px; */
}
</style>
